module.exports = __webpack_public_path__ + "static/media/yeah.edea1fe4.png";